import type { TCompanyReportColumnsSizingKey } from "../../models";
import { hasKeys } from "../objects.helpers";
import type { ColumnSizingState } from "../react-table.features";
import type { TReportsColumnsSizingStorage } from "./report-columns-sizing.storage.helpers.models";
import { localStorageHelpers } from "./storage.helpers";

const getReportColumnsSizingKey = (
  companyId: number,
): TCompanyReportColumnsSizingKey => `${companyId}_reportColumnsSizing`;

const getStoredReportsColumnsSizing = (
  companyId: number,
): TReportsColumnsSizingStorage =>
  localStorageHelpers.getItem<TReportsColumnsSizingStorage>(
    getReportColumnsSizingKey(companyId),
  ) ?? {};

export const getReportColumnsSizingLocalStore = ({
  companyId,
  reportId,
}: {
  companyId: number;
  reportId: number;
}): ColumnSizingState =>
  getStoredReportsColumnsSizing(companyId)[reportId] ?? {};

export const setReportColumnsSizingLocalStore = ({
  companyId,
  reportId,
  columnsSizing,
}: {
  companyId: number;
  reportId: number;
  columnsSizing: ColumnSizingState;
}): void => {
  const { [reportId]: _previousColumnsSizing, ...otherReportsColumnsSizing } =
    getStoredReportsColumnsSizing(companyId);
  // An empty sizing is the report's default layout, so its entry is dropped rather than kept as `{}`.
  const updatedColumnsSizing: TReportsColumnsSizingStorage = hasKeys(
    columnsSizing,
  )
    ? { ...otherReportsColumnsSizing, [reportId]: columnsSizing }
    : otherReportsColumnsSizing;

  localStorageHelpers.setItem<TReportsColumnsSizingStorage>(
    getReportColumnsSizingKey(companyId),
    updatedColumnsSizing,
  );
};
